import {
    type TradeInAemVehicleActionsType,
    TRADE_IN_AEM_FIND_VEHICLE_SET_VEHICLE,
    TRADE_IN_AEM_UPDATE_EXTRA_INFO_PROP,
    TRADE_IN_AEM_UPDATE_VEHICLE_PROP,
} from "../actions/TradeInAemVehicleActions";
import type { TradeInAemVehicleExtraInfoType, TradeInAemVehicleType } from "../../utils/types";

export type TradeInAemVehicleReducerType = {
    vehicle: TradeInAemVehicleType | null;
};

export const initialStateTradeInAemVehicle: TradeInAemVehicleReducerType = {
    vehicle: null,
};

const TradeInAemVehicleReducer = (
    state: TradeInAemVehicleReducerType = initialStateTradeInAemVehicle,
    action: TradeInAemVehicleActionsType,
): TradeInAemVehicleReducerType => {
    switch (action.type) {
        case TRADE_IN_AEM_FIND_VEHICLE_SET_VEHICLE: {
            const { vehicle } = action;
            return { ...state, vehicle };
        }

        case TRADE_IN_AEM_UPDATE_VEHICLE_PROP: {
            const { key, value } = action;

            return state.vehicle ? { ...state, vehicle: { ...state.vehicle, [key]: value } } : state;
        }

        // This updates a property of the 'tmeExtraInfo' property of the vehicle object
        // This property will not be used when calculating the valuation, but we do use it when generating the PDF based on the quoteId
        // The naming of this property was discussed with Peter to make sure it doesn't conflict with other properties
        // We only add info which can't be linked to user to keep GDPR compliance, therefor we don't add the contact info here
        case TRADE_IN_AEM_UPDATE_EXTRA_INFO_PROP: {
            const { key, value } = action;

            const tmeExtraInfo = {
                ...(state.vehicle?.tmeExtraInfo as TradeInAemVehicleExtraInfoType),
                [key]: value,
            };

            return state.vehicle ? { ...state, vehicle: { ...state.vehicle, tmeExtraInfo } } : state;
        }

        default:
            return state;
    }
};

export default TradeInAemVehicleReducer;
